import React from "react"
import PropTypes from "prop-types"
import Markdown from "markdown-to-jsx"
import SanityImage from "gatsby-plugin-sanity-image"
import theme from "styles/theme"

const InlineImage = ({
  mobileImageBreakpoint = 650,
  mobileImage = {},
  image,
  caption,
  alt,
  sizes,
  imageProps = {},
  className,
}) => {
  const hasMobileImage = mobileImage?.asset ? true : false
  return (
    <figure
      css={{
        margin: "3.529em 0",
        borderBottom: caption && `1px solid ${theme.lightGray}`,
        color: theme.textGray,
      }}
      className={className}
    >
      {hasMobileImage && <SanityImage
        {...mobileImage}
        width={746}
        alt={alt || ""}
        sizes={sizes}
        css={{
          display: "block",
          [`@media (min-width: ${parseInt(mobileImageBreakpoint)}px)`]: {
            display: "none",
          },
        }}
        {...imageProps}
      />}
      <SanityImage
        {...image}
        width={746}
        alt={alt || ""}
        sizes={sizes}
        css={{
          display: hasMobileImage ? "none" : "block",
          [`@media (min-width: ${parseInt(mobileImageBreakpoint)}px)`]: {
            display: hasMobileImage ? "block" : null,
          },
        }}
        {...imageProps}
      />
      {caption && (
        <figcaption
          css={{
            ...theme.imageCaption,
            margin: "1.176em 0",
          }}
        >
          <Markdown options={{ forceBlock: true }}>{caption}</Markdown>
        </figcaption>
      )}
    </figure>
  )
}

export default InlineImage

InlineImage.propTypes = {
  mobileImageBreakpoint: PropTypes.number,
  mobileImage: PropTypes.shape({
    hotspot: PropTypes.object,
    crop: PropTypes.object,
    asset: PropTypes.object.isRequired,
  }),
  image: PropTypes.shape({
    hotspot: PropTypes.object,
    crop: PropTypes.object,
    asset: PropTypes.object.isRequired,
  }).isRequired,
  imageProps: PropTypes.object,
  caption: PropTypes.string,
  alt: PropTypes.string,
  sizes: PropTypes.string,
  className: PropTypes.string,
}
